import { useContext } from 'react'
import { useStore } from 'zustand'
import { StoreLocatorContext } from './context'

function useStoreLocatorContext(selector) {
  const store = useContext(StoreLocatorContext)
  if (!store) throw new Error('Missing StoreLocator.Provider in the tree')
  return useStore(store, selector)
}

export default useStoreLocatorContext
